import { FunctionComponent, memo } from "react";
import { IProps } from "./anomaly-summary-count.types";
import { NumericValue } from "@edgetier/client-components";
import "./anomaly-summary-count.scss";

const AnomalySummaryCount: FunctionComponent<IProps> = ({ interactionsCount }) => {
    return (
        <div className="anomaly-summary-count">
            <div className="anomaly-summary-count__value">
                <NumericValue value={interactionsCount} />
            </div>
            <div>
                Related
                <br />
                Interactions
            </div>
        </div>
    );
};

export default memo(AnomalySummaryCount);
